export {LessonEditionModule} from '@modules/lesson-edition/core/lesson-edition.module';

